import { useState } from "react";
import { InputError, findInputError, isFormInvalid } from "./Input";
import { useFormContext, Controller } from "react-hook-form";
import imageCompression from 'browser-image-compression';

export const UploadFile = ({
                               label_text,
                               name,
                               hasError,
                               validation,
                               disable,
                               href,
                               fileName,
                               valueName,
                               maxSizeMB = 1
}) => {

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState('');
    const [firstTime, setFirstTime] = useState(true)
        
    const {formState: {errors}, setValue, control} = useFormContext()

    const inputError = findInputError(errors, name)
    const isInvalid = isFormInvalid(inputError)

    async function handleFileChange(event, onChange) {
        const file = event.target.files[0];

        if (!file) {
            setSelectedFile(null);
            setFileError('');
            onChange(''); // Clear the value in react-hook-form
            return;
        }

        const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes
        if (file.size > maxSizeBytes) {
            setSelectedFile(null);
            setFileError(`اندازه فایل تصویر شما حداکثر ${maxSizeMB} مگابایت باید باشد.`);
            onChange(''); // Clear the value so validation fails
            setValue(name, '', { shouldValidate: true });
            return
        }

        if (file && file.type.startsWith('image/')) {
            setSelectedFile(file);
            setFileError('');

            try {
                let finalFile = file;

                // Only compress if file is over 200KB
                if (file.size > 1024 * 1024) {
                    const options = {
                        maxSizeMB: 0.6, 
                        maxWidthOrHeight: 800,
                        useWebWorker: true,
                        fileType: 'image/png', 
                        initialQuality: 0.5,
                    };

                    let compressedFile = await imageCompression(file, options);
                    
                    // If still over 200KB, compress more aggressively
                    if (compressedFile.size > 1024 * 1024) {
                        const moreAggressiveOptions = {
                            maxSizeMB: 0.6,
                            maxWidthOrHeight: 800,
                            useWebWorker: true,
                            fileType: 'image/png',
                            initialQuality: 0.4,
                        };
                        compressedFile = await imageCompression(file, moreAggressiveOptions);
                    }

                    // If still over 200KB, try one more time with very aggressive settings
                    // if (compressedFile.size > 200 * 1024) {
                    //     const veryAggressiveOptions = {
                    //         maxSizeMB: 0.2,
                    //         maxWidthOrHeight: 400,
                    //         useWebWorker: true,
                    //         fileType: 'image/png',
                    //         initialQuality: 0.15,
                    //     };
                    //     compressedFile = await imageCompression(file, veryAggressiveOptions);
                    // }

                    finalFile = compressedFile;
                }

                const reader = new FileReader();
                reader.onload = () => {
                    const imageData = reader.result;
                    onChange(imageData);
                };
                reader.onerror = () => {
                    setFileError('خطا در خواندن فایل');
                    onChange(''); // Clear the value so validation fails
                    setValue(name, '', { shouldValidate: true });
                };
                reader.readAsDataURL(finalFile);
            } catch (error) {
                console.error('Error compressing image:', error);
                setFileError('خطا در فشرده‌سازی تصویر');
                onChange(''); // Clear the value so validation fails
                setValue(name, '', { shouldValidate: true });
            }
        } else {
            setSelectedFile(null);
            setFileError('لطفا فایل تصویری با فرمت مناسب را انتخاب کنید.');
            onChange(''); // Clear the value so validation fails
            setValue(name, '', { shouldValidate: true });
        }
    }


    const handleButtonClick = () => {
        const id = 'id' + name
        document.getElementById(id).click();
    };

    return(

        <>
            <div className='row justify-content-center mt-4 testing'>
                <div className='col-12 col-md-5 d-flex'>
                    <label className="form-label text-form-title">{label_text}</label>
                    <span className='required-label'>
                        *
                    </span> 
                </div>
            </div>

            <div className='row justify-content-center testing'>
                <div className='col-12 col-md-5 d-flex'>

                    <Controller
                        control={control}
                        name={name}
                        rules={validation}
                        render={({ field: { onChange, onBlur, value, ref } }) => (
                            <>
                                <input
                                    type="file"
                                    id={'id' + name}
                                    style={{ display: 'none' }}
                                    ref={ref}
                                    onBlur={onBlur}
                                    onChange={async (e) => {
                                        setFirstTime(false)
                                        await handleFileChange(e, onChange);
                                    }}

                                />

                                <input
                                type="text"
                                name={name}
                                disabled={disable}
                                className={`form-control text-form-input 
                                ${isInvalid ? "form-control-error" : null}
                                ${firstTime && hasError == 'error' ? "form-control-error" : null}
                                ${firstTime && hasError == 'correct' ? "form-control-correct" : null}
                            `}
                                placeholder="فایل"
                                value={selectedFile ? selectedFile.name : valueName ? valueName : ''}
                                readOnly
                                />

                            {!disable && <button className='btn me-2'
                                style={{"textWrap": "nowrap", "color": "white", "background": "#044448"}}
                                onClick={handleButtonClick}>انتخاب فایل</button>}

                            </>)}
                    />

                    {/*<input*/}
                    {/*    type="file"*/}
                    {/*    id={'id' + name}*/}
                    {/*    style={{ display: 'none' }}*/}
                    {/*    // {...(disable ? {} : register(name, validation))}*/}
                    {/*    {...productImageField}*/}
                    {/*    onChange={(e) => {*/}
                    {/*        if(validation) {*/}
                    {/*            productImageField.onChange(e);*/}
                    {/*        }*/}
                    {/*        setFirstTime(false)*/}
                    {/*        handleFileChange(e);*/}
                    {/*    }}*/}
                    {/*    */}
                    {/*/>*/}

                    {/*<input */}
                    {/*    type="text"*/}
                    {/*    name={name}*/}
                    {/*    disabled={disable}*/}
                    {/*    className={`form-control text-form-input */}
                    {/*        ${isInvalid ? "form-control-error" : null}*/}
                    {/*        ${firstTime && hasError == 'error' ? "form-control-error" : null}*/}
                    {/*        ${firstTime && hasError == 'correct' ? "form-control-correct" : null}*/}
                    {/*    `}*/}
                    {/*    placeholder="فایل" */}
                    {/*    value={selectedFile ? selectedFile.name : valueName ? valueName : ''}*/}
                    {/*    readOnly*/}
                    {/*/>*/}

                    {/*{!disable && <button className='btn me-2'*/}
                    {/*         style={{"textWrap": "nowrap", "color": "white", "background": "#044448"}}*/}
                    {/*         onClick={handleButtonClick}>انتخاب فایل</button>}*/}

                </div>
                

            </div>
            {href && <div className='row justify-content-center testing mt-1'>
                <div className='col-12 col-md-5'>
                    <a href={href} download={fileName}>
                        دانلود نمونه
                    </a>
                </div>
            </div>}

            {fileError &&
                <div className='row justify-content-center testing'>
                    <div className='col-12 col-md-5'>
                         <InputError message={fileError} show={true} key={'fileError' + name}/>
                    </div>
                </div>
            }

            {isInvalid && <div className='row justify-content-center testing'>
                <div className='col-12 col-md-5'>
                    <InputError
                        show={isInvalid}
                        message={inputError?.error?.message}
                        key={inputError?.error?.message}
                    />
                </div>
            </div>}

            
        </>
    )

}